<template>
  <a-data-table
    :headers="headers"
    :items="filterAgendaData"
    item-key="index"
    :items-per-page="10"
    class="elevation-1"
    style="width: 100%"
    :footer-props="{
      'items-per-page-text': $t('lblRowsPerPage'),
    }"
    sort-by="agendaName"
    :sort-desc="false"
    :must-sort="true"
  >
    <template v-slot:[`item.agendaName`]="{ item }">
      <agenda-search-topic-item
        :item="item"
        :isDeleted="item.isDeleted"
      ></agenda-search-topic-item>
    </template>
    <template v-slot:[`item.priority`]="{ item }">
      <colored-chip-template
        chipColumn="priority"
        :textValue="item.priority"
      ></colored-chip-template>
    </template>
    <template v-slot:[`item.frequency`]="{ item }">
      <colored-chip-template
        chipColumn="frequency"
        :textValue="item.frequency"
      ></colored-chip-template>
    </template>
    <template v-slot:[`item.category`]="{ item }">
      <a-chip
        style="color: #333333"
        class="minute"
        outlined
        small
        label
        :color="getAgendaCategoryColor(item.category)"
        dark
        >{{ item.category }}</a-chip
      >
    </template>
    <template v-slot:[`item.meetingType`]="{ item }">
      <a-chip
        style="color: #333333"
        class="minute"
        outlined
        small
        label
        :color="getMeetingTypeColor(item.meetingType)"
        dark
        >{{ item.meetingType }}</a-chip
      >
    </template>
  </a-data-table>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import coloredChipTemplate from "../agenda/coloredChipTemplate.vue";
import AgendaSearchTopicItem from "./AgendaSearchTopicItem.vue";
import customFunctions from "@/codeFiles/taskHelper.js";

export default {
  components: { coloredChipTemplate, AgendaSearchTopicItem },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      agendaListData: (state) => state.agenda.agendaList,
    }),
    headers() {
      return [
        {
          value: "agendaName",
          text: this.$t("search.agendaName"),
          type: "agenda",
          class: "header header-text",
          width: 400,
        },
        {
          value: "meetingType",
          text: this.$t("agenda.lblMeetingType"),
          type: "agenda",
          class: "header header-text",
        },
        {
          value: "category",
          text: this.$t("agenda.hCategory"),
          type: "agenda",
          class: "header header-text",
        },
        {
          value: "frequency",
          text: this.$t("agenda.hFrequency"),
          type: "agenda",
          class: "header header-text",
        },
        {
          value: "priority",
          text: this.$t("agenda.hPriority"),
          type: "agenda",
          class: "header header-text",
        },
      ];
    },
    ...gettersMap(),
    filterAgendaData() {
      return this.items
        .map((obj) => {
          return {
            ...obj,
            isDeleted: !this.agendaListData.some((item) => item.id === obj.id),
          };
        })
        .sort((a, b) => {
          if (a.agendaName < b.agendaName) return 1;
          if (a.agendaName > b.agendaName) return -1;
          return 0;
        });
    },
  },
  methods: {
    shadeColor(color, percentage) {
      return customFunctions.shadeColor(color, percentage);
    },
    getAgendaCategoryColor(cat) {
      const category = this.categoriesList.find(
        (c) => String(c.name).toLowerCase() === String(cat).toLowerCase()
      ) || { order: 0, name: cat, color: "#2471A3" };
      return category.color;
    },
    getMeetingTypeColor(type) {
      const meetingType = this.meetingTypesList.find(
        (c) => String(c.label).toLowerCase() === String(type).toLowerCase()
      ) || { label: type, color: "#F5CBA7" };

      return this.shadeColor(meetingType.color, -25);
    },
  },
};

function gettersMap() {
  return mapGetters({
    categoriesList: "tenant/agendaCategories",
    meetingTypesList: "tenant/agendaMeetingTypes",
  });
}
</script>

<style>
</style>